export const languageCode = {
  NB: "nb",
  NN: "nn",
  EN: "en",
} as const

export type LanguageCode = (typeof languageCode)[keyof typeof languageCode]

export const languages: { name: string; code: LanguageCode }[] = [
  { name: "Norsk Bokmål", code: languageCode.NB },
  { name: "Norsk Nynorsk", code: languageCode.NN },
  { name: "English", code: languageCode.EN },
]
